// src/components/FileUpload/FileUpload.mjs
import React from 'react';


const FileUpload = ({
  title,
  description,
  acceptedFileTypes,
  fileName,
  isLoading,
  uploadError,
  uploadSuccess,
  uploadMessage,
  onFileChange,
  onClear,
  onUpload
}) => {
  return (
    <div className="p-4 sm:p-6">
      <h2 className="text-lg sm:text-xl font-semibold text-gray-800 mb-2">{title}</h2>
      <p className="text-sm text-gray-600 mb-4">{description}</p>

      <div className="flex flex-wrap items-center gap-3 mb-4">
        <input
          type="file"
          accept={acceptedFileTypes}
          onChange={onFileChange}
          className="hidden"
          id={`file-input-${title.replace(/\s+/g, '-').toLowerCase()}`}
          disabled={isLoading}
        />
        <label
          htmlFor={`file-input-${title.replace(/\s+/g, '-').toLowerCase()}`}
          className="inline-flex items-center justify-center min-h-[44px] sm:min-h-0 px-4 py-2 bg-gray-100 border border-gray-300 rounded-lg text-gray-700 cursor-pointer hover:bg-gray-200 transition-colors font-medium"
        >
          Choose File
        </label>
        {fileName && (
          <div className="flex items-center gap-2 min-w-0 max-w-full pl-3 pr-1 sm:px-3 py-1 sm:py-2 bg-gray-50 rounded-lg border border-gray-200">
            <span className="min-w-0 break-words text-sm text-gray-700">{fileName}</span>
            <button
              aria-label="Clear selected file"
              className="shrink-0 w-11 h-11 sm:w-6 sm:h-6 flex items-center justify-center text-gray-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors"
              onClick={onClear}
            >
              X
            </button>
          </div>
        )}
      </div>

      <button
        className="w-full sm:w-auto min-h-[44px] sm:min-h-0 px-6 py-2 bg-stanford-red text-white rounded-lg hover:bg-stanford-light-red transition-colors font-medium disabled:opacity-50 disabled:cursor-not-allowed"
        onClick={onUpload}
        disabled={isLoading || !fileName}
      >
        {isLoading ? 'Uploading...' : 'Upload'}
      </button>

      {uploadError && <p className="mt-3 text-sm text-red-600">{uploadError}</p>}
      {uploadSuccess && <p className="mt-3 text-sm text-green-600">{uploadMessage}</p>}
    </div>
  );
};

export default FileUpload;
